import { render } from "./hadrianLabel.vue?vue&type=template&id=0b08ff27&ts=true"
import script from "./hadrianLabel.ts?vue&type=script&lang=ts"
export * from "./hadrianLabel.ts?vue&type=script&lang=ts"

import "./hadrianLabel.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__